import { useAppSelector } from '@/store'
import { selectCurrency } from '@/store/settingsSlice'
import { formatCurrency } from '@safe-global/utils/utils/formatNumber'
import { Typography } from '@safe-global/views/components/ui/typography'

/** Renders a raw fiat amount formatted in the user's selected currency. Shared across features. */
const FiatBalance = ({ value }: { value: string | number | undefined }) => {
  const currency = useAppSelector(selectCurrency)

  if (value === undefined) return null

  return <Typography variant="paragraph-small-medium">{formatCurrency(value, currency)}</Typography>
}

export default FiatBalance
